// @flow

import { I18n } from 'react-redux-i18n';
import { addNotification as notify } from 'reapop';
import toMessage from '../services/i18nService';
import { errorObject } from './handleError';

export function notifySuccess(reduxDispatch: Function) {
  return (response: Object) => {
    reduxDispatch(notify({
      message: 'Les modifications ont bien été prises en compte',
      status: 'success',
    }));
    return response;
  };
}

export function notifyApolloError(err: EventHandler) {
  return (dispatch: () => void) => {
    if (!err) {
      return;
    }
    let errorResponse = err;
    if (typeof err.then !== 'function') {
      errorResponse = Promise.resolve(errorObject);
    }
    return (errorResponse: Object).then((errorJson) => {
      dispatch(notify({
        message: I18n.t(`wsError.${errorJson.errorCode}`, toMessage(errorJson)),
        status: 'error',
      }));
      if (errorJson.errorCode === 'AUTHENTIFICATION_EXPIRED') {
        sessionStorage.clear();
      }
    });
  };
}

export function notifyApolloInfo(message: string) {
  return (dispatch: () => void) => {
    if (!message) {
      return;
    }
    dispatch(notify({
      message: message,
      status: 'info',
    }));
  }
}

export function notifyInfoMallDisabledHeader(header: string) {
  const isEvent: boolean = header === I18n.t('header.EVENTS');
  const message: string = I18n.t(`mallData.NO_DATA${isEvent ? '_EVENTS' : ''}`, { page: header })
  return notifyApolloInfo(message);
}
